import styled, { css } from 'styled-components';
import { rem } from 'polished';

interface IStyledBadge {
  theme: any;
  className: any;
  color: string;
  large: boolean;
  xlarge: boolean;
  noHover: boolean;
  stretch: boolean;
  selected: boolean;
  rounded: boolean;
}

export const StyledBadge = styled.div.attrs(
  ({ theme, color }: IStyledBadge) => {
    return {
      textColor: theme.tags[color].color,
      bgColor: theme.tags[color].bg,
      textColorHover: theme.tags[color].colorHover,
      bgColorHover: theme.tags[color].bgHover,
    };
  },
)<IStyledBadge>`
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: center;
  width: fit-content;
  text-transform: uppercase;
  background: ${({ bgColor }) => bgColor};
  border-radius: ${rem(`6px`)};
  border: 1px solid transparent;
  height: ${rem(`16px`)};
  padding: 0 ${rem(`10px`)};
  transition: all 0.2s ease-in-out;
  .badge__right-icon,
  .badge__left-icon,
  .badge__text {
    color: ${({ textColor }) => textColor};
    transition: color 200ms ease-in-out;
  }
  .badge__text {
    flex: 0 1 auto;
    font-size: ${rem(`12px`)};
  }
  .badge__right-icon,
  .badge__left-icon {
    fill: ${({ textColor }) => textColor};
    font-size: ${rem(`14px`)};
  }
  .badge__left-icon {
    margin-right: ${rem(`3px`)};
  }
  .badge__right-icon {
    margin-left: ${rem(`3px`)};
  }

  ${({ stretch }) => {
    return (
      stretch &&
      css`
        justify-content: flex-start;
        width: 100%;
        .badge__text {
          flex: 1 0 auto;
        }
      `
    );
  }}

  ${({ large }) => {
    return (
      large &&
      css`
        height: ${rem(`22px`)};
        .badge__text {
          font-size: ${rem(`14px`)};
        }
        .badge__left-icon {
          margin-right: ${rem(`6px`)};
          font-size: ${rem(`16px`)};
        }
        .badge__right-icon {
          margin-left: ${rem(`6px`)};
        }
      `
    );
  }}

  ${({ xlarge }) => {
    return (
      xlarge &&
      css`
        height: ${rem(`34px`)};
        .badge__text {
          font-size: ${rem(`18px`)};
        }
        .badge__left-icon {
          margin-right: ${rem(`9px`)};
          font-size: ${rem(`20px`)};
        }
        .badge__right-icon {
          margin-left: ${rem(`9px`)};
        }
      `
    );
  }}

  ${({ selected, bgColorHover, textColorHover }) => {
    return (
      selected &&
      css`
        border: 1px solid ${bgColorHover};
        background: ${bgColorHover};
        .badge__right-icon,
        .badge__left-icon,
        .badge__text {
          color: ${textColorHover};
        }
      `
    );
  }}

  ${({
    noHover,
    textColor,
    bgColor,
    bgColorHover,
    textColorHover,
    selected,
  }) => {
    return (
      !noHover &&
      css`
        &:hover {
          border: 1px solid ${selected ? `transparent` : bgColorHover};
          background: ${selected ? bgColor : bgColorHover};
          .badge__right-icon,
          .badge__left-icon,
          .badge__text {
            color: ${selected ? textColor : textColorHover};
          }
        }
      `
    );
  }}

  ${({ rounded, large }) => {
    return (
      rounded &&
      css`
        border-radius: 50%;
        height: auto;
        padding: ${large ? rem(`5px`) : rem(`3px`)};
        margin: 0;
        .badge__left-icon {
          margin: 0;
        }
      `
    );
  }}
`;
